import { render, staticRenderFns } from "./regional-agent-record.vue?vue&type=template&id=60c0aa81&scoped=true&"
import script from "./regional-agent-record.vue?vue&type=script&lang=js&"
export * from "./regional-agent-record.vue?vue&type=script&lang=js&"
import style0 from "./regional-agent-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./regional-agent-record.vue?vue&type=style&index=1&id=60c0aa81&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0aa81",
  null
  
)

export default component.exports